<template>
    <div class="modal-text">
    <p>
      Lorsque vous créez un projet de n'importe quel type, vous pouvez inviter des participants <b>grâce à leur adresse mail.</b> 
      Si l'utilisateur invité <b>n'a pas encore de compte sur CodeSnippet</b>, il recevra l'invitation par mail pour se créer un compte et accepter ou refuser votre invitation.
    </p>

    <br />

    <p>
        Pour gérer les différentes invitations que vous avez reçues, vous pouvez vous rendre sur la page 
        <router-link class="underline" :to="{ name: 'Dashboard' }">
            <span>Dashboard</span>
        </router-link>.
    </p>

    <br />
    
    <img class="my-5" :src="ImgInvites" />

    <br />

    <p>
        Pour chaque invitation, vous pouvez <b>accepter</b> ou <b>refuser</b>. 
        <b>Attention, vous ne pouvez pas annuler ce choix.</b>
        Dans le cas où vous avez refusé une invitation par erreur, contactez l'administrateur du projet 
        pour qu'il puisse vous inviter à nouveau.
    </p>

    <hr class="my-5" />

    <h3>Liens utiles</h3>

    <ul class="list-disc list-inside">
      <li class="my-1">
        <router-link class="link" :to="{ name: 'Dashboard' }">
          <span>Gérer mes invitations</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>

import ImgInvites from '~/assets/img/guide/guide_img_invites.png';

export default { 
    name: "ConnectionDialogContent",
    data: () => ({
        ImgInvites: ImgInvites,
    }),
}
</script>
